var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "#80c5d6 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1729_821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8122 20.8564C32.7594 20.8564 33.6677 20.4802 34.3375 19.8104M31.8122 20.8564C30.865 20.8564 29.9567 20.4802 29.2869 19.8104M31.8122 20.8564V23.5352M34.3375 19.8104C35.0072 19.1407 35.3835 18.2323 35.3835 17.2852M34.3375 19.8104L36.2322 21.7039M35.3835 17.2852C35.3835 16.338 35.0072 15.4296 34.3375 14.7599M35.3835 17.2852H38.0622M34.3375 14.7599C33.6677 14.0902 32.7594 13.7139 31.8122 13.7139M34.3375 14.7599L36.2322 12.8652M31.8122 13.7139C30.865 13.7139 29.9567 14.0902 29.2869 14.7599M31.8122 13.7139V11.0352M29.2869 14.7599C28.6172 15.4296 28.241 16.338 28.241 17.2852M29.2869 14.7599L27.3922 12.8652M28.241 17.2852C28.241 18.2323 28.6172 19.1407 29.2869 19.8104M28.241 17.2852H25.5622M29.2869 19.8104L27.3922 21.7039M31.2172 11.0352H32.4072M35.811 12.4452L36.6522 13.2864M38.0622 16.6902V17.8802M36.6522 21.2839L35.811 22.1252M32.4072 23.5352H31.2172M27.8135 22.1252L26.9722 21.2839M25.5622 17.8802V16.6902M26.9722 13.2864L27.8135 12.4452M29.291 34.9502L23.9547 36.0177M24.4822 29.9639L21.9647 31.0277C21.766 31.1095 21.5528 31.1501 21.3379 31.1471C21.123 31.1441 20.911 31.0975 20.7147 31.0102C20.5147 30.9215 20.3344 30.7939 20.1842 30.6349C20.034 30.4759 19.9169 30.2886 19.8397 30.0839C19.6892 29.6959 19.6862 29.2662 19.8313 28.8761C19.9765 28.4861 20.2597 28.1629 20.6272 27.9677L23.1447 26.7102C23.4171 26.569 23.7161 26.4867 24.0223 26.4686C24.3285 26.4505 24.6351 26.497 24.9222 26.6052L30.0947 28.6439",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.179 36.0605H15.9602L19.359 38.653C19.5183 38.8321 19.7409 38.9423 19.9799 38.9605C20.2189 38.9787 20.4557 38.9034 20.6402 38.7505L25.3902 34.828C25.5781 34.6728 25.6982 34.4506 25.725 34.2084C25.7519 33.9662 25.6834 33.723 25.534 33.5305L22.9165 30.6255M20.3565 28.1455L20.0815 27.9192C19.809 27.7169 19.4893 27.5877 19.1528 27.5439C18.8163 27.5002 18.4741 27.5433 18.159 27.6692L14.1777 29.368",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 36.8964H12.9025C13.2379 36.9135 13.5665 36.7976 13.8169 36.5738C14.0673 36.3501 14.2194 36.0366 14.24 35.7014V29.7289C14.219 29.3939 14.0669 29.0808 13.8165 28.8573C13.5661 28.6338 13.2377 28.518 12.9025 28.5352H9.9375M33.5937 36.8964H30.625C30.2896 36.9135 29.961 36.7976 29.7106 36.5738C29.4602 36.3501 29.3081 36.0366 29.2875 35.7014V29.7289C29.3085 29.3939 29.4606 29.0808 29.711 28.8573C29.9614 28.6338 30.2898 28.518 30.625 28.5352H33.59M21.845 17.2852H10.595M10.595 17.2852L14.345 13.5352M10.595 17.2852L14.345 21.0352",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1729_821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.af7ce67e89d702760226bf2d27da9e66.svg";
export { ForwardRef as ReactComponent };